import { get } from 'lodash';
import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';

import { FoodBasedAnalysisFieldEnum } from 'Common/FieldEnum';
import { makeOptionsDataWithEmpty, makeOptionsData } from 'Common/FormHelper';
import { FOOD_BASED_ANALYSIS_FORM_NAME } from 'Common/FormEnum';

const root = (state) => get(state, 'FoodBasedAnalysisState');

export const getNutritionStandardsLoading = (state) =>
  get(root(state), 'getNutritionStandards.loading');
export const getNutritionStandardsResult = (state) =>
  get(root(state), 'getNutritionStandards.data');
export const getNutritionStandardsErrors = (state) =>
  get(root(state), 'getNutritionStandards.errors');

export const getCycleMenusLoading = (state) =>
  get(root(state), 'getCycleMenus.loading');
export const getCycleMenusResult = (state) =>
  get(root(state), 'getCycleMenus.data');
export const getCycleMenusErrors = (state) =>
  get(root(state), 'getCycleMenus.errors');

export const nutritionStandardOptions = createSelector(
  [getNutritionStandardsResult, getCycleMenusResult],
  (nutritionStandards, cycleMenus) => {
    if (!cycleMenus.length) {
      return [];
    }

    const filtered = nutritionStandards.filter((standard) =>
      cycleMenus.find((cycleMenu) => cycleMenu.NutritionStdID === standard.Id)
    );

    return makeOptionsDataWithEmpty(filtered);
  }
);

const selector = formValueSelector(FOOD_BASED_ANALYSIS_FORM_NAME);

export const cycleMenuOptions = createSelector(
  [
    getCycleMenusResult,
    (state) => selector(state, FoodBasedAnalysisFieldEnum.NutritionStandard),
  ],
  (cycleMenus, nutritionStandard) => {
    let options = cycleMenus;

    if (nutritionStandard) {
      options = cycleMenus.filter(
        (cycleMenu) => cycleMenu.NutritionStdID === nutritionStandard
      );
    }

    return makeOptionsData(options);
  }
);



// WEBPACK FOOTER //
// ./src/pages/reports/menus/foodbasedanalysisreport/state/selectors.js